export default __webpack_public_path__ + "static/media/GreyOrder.efd3c4f5.svg";